import RocksPlantsList from './RocksPlantList';

export default {
    list: RocksPlantsList,
}